import Vue from "vue";
import ElementUI from "element-ui";
import { Dialog } from "element-ui";

// 修改 Dialog 的默认配置
Dialog.props.appendTo = {
  type: [String, HTMLElement],
  default: () => {
    const fullscreenElement = document.fullscreenElement;
    return fullscreenElement &&
      fullscreenElement.classList.contains("prism-player")
      ? ".prism-player"
      : "body";
  },
};

// 注册Element UI组件
Vue.use(ElementUI);
